import { render, staticRenderFns } from "./RequestForm.vue?vue&type=template&id=2996e692&"
import script from "./RequestForm.vue?vue&type=script&lang=js&"
export * from "./RequestForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports